import React, { FC, useMemo, useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

type AddressGoogleProp = {
    className?: string;
    value: string;
    setValue: (
        addressValue: {
            offset: number;
            value: string;
        }[],
        address: string
    ) => void;
};

const AddressGoogle: FC<AddressGoogleProp> = ({
    className = "",
    value,
    setValue,
}) => {
    const [focused, setFocused] = useState<boolean>(false);
    const [address, setAddress] = useState<string>(value);

    const borderClassName = useMemo(() => {
        if (!focused) {
            return "borderGrey";
        }

        if (address?.length === undefined || address === "") {
            return "borderRed";
        }

        return "borderGreen";
    }, [address, focused]);

    const handleChange = (
        args: {
            value: {
                terms: { offset: number; value: string }[];
                structured_formatting: { main_text: string };
            };
        } | null
    ) => {
        if (!args) {
            setAddress("");
            setValue([], "");
            return;
        }

        setAddress(args.value.structured_formatting.main_text);
        setValue(args.value.terms, args.value.structured_formatting.main_text);
    };

    return (
        <div
            className={`${className} ${borderClassName}`}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
        >
            <GooglePlacesAutocomplete
                selectProps={{
                    isClearable: true,
                    value: address
                        ? { value: address, label: address }
                        : value
                        ? { value, label: value }
                        : null,
                    onChange: handleChange,
                    placeholder: (
                        <div style={{ color: "#c7c7c7" }}>
                            Write your address...
                        </div>
                    ),
                    noOptionsMessage: () => null,
                    loadingMessage: () => "Loading...",
                    styles: {
                        input: () => ({
                            color: "#777e91",
                            fontFamily: "GeneralSans-Regular",
                        }),
                        singleValue: () => ({
                            color: "#777e91",
                            fontFamily: "GeneralSans-Regular",
                        }),
                    },
                }}
                apiOptions={{
                    libraries: ["places", "geometry"],
                    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
                }}
                apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}
            />
        </div>
    );
};

export default AddressGoogle;
